// node-modules
import scrollBarWidth from 'scrollbarwidth';
import { TweenLite } from 'gsap/TweenLite';
import { ScrollToPlugin } from 'gsap/all';

// constants
import { DOCUMENT_ELEMENT } from '@/scripts/constants';

// standalone components
import '@/components/particles';
import '@/components/preloader';
import '@/components/animations';
import '@/components/tabs';

// functional components
import { MobileMenu } from '@/components/MobileMenu';
import { NewsSlider, FadeSlider, CoverflowSlider } from '@/components/sliders';
import { cropBlock } from '@/components/cropBlock';

// scrollmagic scenes
import '@/scripts/scrollmagic';
import { headerToggle } from '@/scrollmagic/scenes/header';

// assets
import '@/fonts';
import '@/styles/main.scss';

// eslint-disable-next-line no-unused-vars
const plugins = [ScrollToPlugin];

DOCUMENT_ELEMENT.style.setProperty('--scrollbar-width', `${scrollBarWidth()}px`);

document.addEventListener('DOMContentLoaded', () => {
  // init header toggle
  headerToggle();

  // init crop block
  cropBlock();

  // init mobile menu
  const menuElement = document.querySelector('[data-component="mobile-menu"]');
  if (menuElement) {
    const menu = new MobileMenu({
      element: menuElement,
      menuTriggers: document.querySelectorAll('[data-role="menu-trigger"]'),
      menuContent: menuElement.querySelector('[data-role="menu-content"]'),
      initialState: {
        active: false,
      },
    });
    menu.init();
  }

  // init scroll to top
  document.querySelectorAll('[data-scroll-to]')
    .forEach((element) => {
      const selector = element.hash;
      const destination = document.querySelector(selector);
      if (destination) {
        element.addEventListener('click', (e) => {
          e.preventDefault();
          const { top } = $(destination).offset();
          TweenLite.to(window, 0.8, { scrollTo: { y: top, autokill: false } });
        });
      }
    });

  // init sliders
  document.querySelectorAll('[data-component="news-slider"]')
    .forEach((element) => {
      const swiper = new NewsSlider({ element });
      swiper.init();
    });

  document.querySelectorAll('[data-component="fade-slider"]')
    .forEach((element) => {
      const swiper = new FadeSlider({ element });
      swiper.init();
    });

  document.querySelectorAll('[data-component="coverflow-slider"]')
    .forEach((element) => {
      const swiper = new CoverflowSlider({ element });
      swiper.init();
    });
});
